/**
 * The raw brand values the Material UI theme is built from.
 *
 * The same "Ocean blue with a brass accent" palette as the React Native client
 * (ReactNative/libs/ui/src/lib/tokens.js). Kept separate from theme.js so the
 * brand can be read and changed without stepping through Material UI's theme
 * structure, and so both clients' token files can be compared side by side.
 *
 * Nothing outside libs/ui should import from here — components consume the
 * theme, not the tokens, so that a value is never used somewhere the theme
 * cannot later override it.
 */

export const colors = {
  primary: '#0B6E99',
  primaryDark: '#063A52',
  secondary: '#4A90A4',
  accent: '#B8863A',

  background: '#F4F9FB',
  surface: '#EFF6F8',
  surfaceRaised: '#FFFFFF',
  border: '#D7E7EC',

  text: '#0B2E3D',
  textMuted: '#4A7284',
  textInverse: '#FFFFFF',

  danger: '#B4402E',
  success: '#16A34A',

  gradientStart: '#0E86B8',
  gradientEnd: '#063A52'
};

/**
 * Material UI's spacing multiplier. theme.spacing(2) is 8px, and every gap and
 * pad in the application is expressed in these units rather than in pixels.
 */
export const spacingUnit = 4;

export const radii = {
  sm: 6,
  md: 10,
  lg: 16,
  pill: 999
};

export const typography = {
  fontFamily: "'Segoe UI', system-ui, -apple-system, 'Helvetica Neue', Arial, sans-serif",
  /**
   * Material UI's base `typography.fontSize` must be a number of pixels — it is
   * arithmetic input for the rem conversions, not a CSS value. Passing the
   * '0.9375rem' string below makes MUI warn and fall back to its own default.
   */
  basePx: 15,
  h1: '1.75rem',
  h2: '1.375rem',
  h3: '1.125rem',
  body: '0.9375rem',
  caption: '0.8125rem'
};

/** The brand gradient, used on the sign-in screen and nowhere else. */
export const gradient = `linear-gradient(135deg, ${colors.gradientStart} 0%, ${colors.gradientEnd} 100%)`;

export const layout = {
  contentMaxWidth: 'lg',
  authCardMaxWidth: 420
};
